import { cookieText } from './cookieText';

export function getPolicy(lang: string): JSX.Element {
  switch (lang) {
    case 'cs':
      return csText();
    case 'sk':
      return skText();
    case 'uk':
      return ukText();
    case 'pl':
      return plText();
    case 'en':
    default:
      return enText();
  }
}

export function csText(): JSX.Element {
  return (
    <>
      <h1>Zásady používání Cookies</h1>
      <h2>Správce osobních údajů</h2>
      <p>
        Dramox s.r.o., se sídlem na adrese Bucharova 2928/14a, Stodůlky, 158 00 Praha 5, Aspira Business Centre,
        společnost zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 332337
      </p>
      <p>
        Kontaktní e-mail:<a href="mailto:jeviste@dramox.cz"> jeviste@dramox.cz</a>.
      </p>
      <p>
        Cílem této stránky je shrnutí základních informací o cookies využívaných v&nbsp;rámci stránky
        www.dramox.cz&nbsp;
      </p>
      <h2>Používání cookies</h2>
      <p>
        Cookies jsou malé textové soubory, které stránka Dramox ukládá do vašeho počítače. Tyto soubory se používají k
        zajištění chodu nebo efektivnějšímu využití našich stránek a k zajištění některých služeb a funkcí pro
        uživatele. Cookies mohou být na vašem zařízení ukládány nebo využívány pouze na základě vašeho souhlasu, s
        výjimkou souborů cookie, které jsou nezbytně nutné zajištění funkce našich stránek. Účelem této stránky je
        poskytnout Vám nezbytné informace týkající se používání cookies a ukládání cookies ve vašem zařízení, abyste se
        mohli svobodně rozhodnout, zda chcete umožnit uložení cookies do vašeho zařízení.
      </p>
      <p>
        Cookies mohou být buď trvalé, nebo platné po dobu tzv. relace. Trvalé cookies jsou textové soubory posílaný
        serverem Vašemu internetovému prohlížeči, který poté, co jej prohlížeč uloží, zůstává platný až do nastaveného
        data konce platnosti. Cookies platné po dobu relace ztratí platnosti na konci relace uživatele poté, co zavřete
        prohlížeč. Účel používání různých cookies je uveden níže v těchto zásadách.
      </p>
      {cookieText('cs')}
      <h2>Změna nastavení cookies v prohlížeči</h2>
      <ul>
        <li>Zvolte, zda si přejete cookies přijmout.</li>
        <li>
          Ve většině internetových prohlížečů lze výše cookies spravovat v nastavení prohlížeče. Nastavením vašeho
          internetového prohlížeče se můžete přijímání cookies vyhnout. Metoda použitá k zablokování cookies bude
          záviset na webovém prohlížeči. Nápovědu najdete v prohlížeči pod příslušnou záložkou.
        </li>
        <li>
          Více informací o cookies a o tom, jak zjistit, jaké cookies byly nastaveny a jak je spravovat a odstraňovat,
          najdete na internetových stránkách <a href="http://www.aboutcookies.org">www.aboutcookies.org</a> a{' '}
          <a href="http://www.allaboutcookies.org">www.allaboutcookies.org</a>.
        </li>
        <li>Upozorňujeme, že v případě změny nastavení cookies nemusí být k dispozici všechny funkce naší služby.</li>
        <li>
          Pokud cookies nepřijmete, bude jejich používání omezeno na nezbytné cookies nutné k&nbsp;provozu našich
          stránek a cookies třetích stran pro nemarketingové účely.
        </li>
      </ul>
      <h2>Osobní údaje a cookies</h2>
      <p>Osobní údaje, které o vás uchováváme, mohou být spojeny s vybranými cookies.</p>
      <h2>Zásady zpracování osobních údajů při používání cookies</h2>
      <p>
        Tyto Zásady používání souborů cookies tvoří nedílnou součást Zásad zpracování osobních údajů na našich
        stránkách, kde najdete veškeré detaily ke zpracování osobních údajů.
      </p>
      <h2>Kontakt</h2>
      <p>V&nbsp;případě, že budete mít k&nbsp;problematice cookies jakékoli dotazy, neváhejte nás kontaktovat:</p>
      <p>
        E-mail: <a href="mailto:jeviste@dramox.cz">jeviste@dramox.cz</a>
      </p>
      <p>Adresa: Dramox s.r.o., Bucharova 2928/14a, Stodůlky, 158 00 Praha 5</p>
      <p>Tato pravidla nabývají účinnosti dnem 1. 10. 2020.</p>
    </>
  );
}

export function skText(): JSX.Element {
  return (
    <>
      <h1>Zásady používania Cookies</h1>
      <h2>Prevádzkovateľ osobných údajov</h2>
      <p>
        Dramox s.r.o., so sídlom na adrese Bucharova 2928/14a, Stodůlky, 158 00 Praha 5, Aspira Business Centre,
        spoločnosť zapísaná v obchodnom registri vedenom Mestským súdom v Prahe, oddiel C, vložka 332337
      </p>
      <p>
        Kontaktný e-mail:<a href="mailto:jeviste@dramox.cz"> jeviste@dramox.cz</a>.
      </p>
      <p>
        Cieľom tejto stránky je zhrnutie základných informácií o súboroch cookie využívaných v&nbsp; rámci stránky
        www.dramox.sk&nbsp;
      </p>
      <h2>Používanie cookies</h2>
      <p>
        Cookies sú malé textové súbory, ktoré stránka Dramox ukladá do Vášho počítača. Tieto súbory sa používajú na
        zabezpečenie chodu alebo efektívnejšieho využitia našich stránok a na zabezpečenie niektorých služieb a funkcií
        pre užívateľov. Cookies môžu byť na Vašom zariadení ukladané alebo využívané iba na základe Vášho súhlasu, s
        výnimkou súborov cookie, ktoré sú nevyhnutné na zaistenie funkcie našich stránok. Účelom tejto stránky je
        poskytnúť Vám nevyhnutné informácie týkajúce sa používania súborov cookie a ukladania týchto súborov vo Vašom
        zariadení, aby ste sa mohli slobodne rozhodnúť, či chcete umožniť uloženie cookies do Vášho zariadenia.
      </p>
      <p>
        Cookies môžu byť buď trvalé, alebo platné počas tzv. relácie. Trvalé cookies sú textové súbory posielané
        serverom Vášmu internetovému prehliadaču, ktorý po tom, čo ho prehliadač uloží, zostáva platný až do nastaveného
        dátumu konca platnosti. Súbory cookie platné počas relácie stratia platnosť na konci relácie používateľa po
        zatvorení prehliadača. Účel používania rôznych súborov cookie je uvedený nižšie v týchto zásadách.
      </p>
      {cookieText('sk')}
      <h2>Zmena nastavenia cookies v prehliadači</h2>
      <ul>
        <li>Zvoľte, či si prajete cookies prijať.</li>
        <li>
          Vo väčšine internetových prehliadačov je možné vyššie uvedené cookies spravovať v nastavení prehliadača.
          Nastavením Vášho internetového prehliadača sa môžete prijímaniu cookies vyhnúť. Metóda použitá na zablokovanie
          cookies bude závisieť od webového prehliadača. Pomoc nájdete v prehliadači pod príslušnou záložkou.
        </li>
        <li>
          Viac informácií o cookies a o tom, ako zistiť, aké cookies boli nastavené a ako ich spravovať a odstraňovať,
          nájdete na internetových stránkach <a href="http://www.aboutcookies.org">www.aboutcookies.org</a> a{' '}
          <a href="http://www.allaboutcookies.org">www.allaboutcookies.org</a>.
        </li>
        <li>
          Upozorňujeme, že v prípade zmeny nastavenia cookies nemusia byť k dispozícii všetky funkcie našej služby.
        </li>
        <li>
          Ak cookies neprijmete, bude ich používanie obmedzené na nevyhnutné cookies potrebné na prevádzku našich
          stránok a cookies tretích strán na nemarketingové účely.
        </li>
      </ul>
      <h2>Osobné údaje a cookies</h2>
      <p>Osobné údaje, ktoré o Vás uchovávame, môžu byť spojené so súbormi cookie.</p>
      <h2>Zásady spracúvania osobných údajov pri používaní cookies</h2>
      <p>
        Tieto Zásady používania súborov cookies tvoria neoddeliteľnú súčasť Zásad spracúvania osobných údajov na našich
        stránkach, kde nájdete všetky detaily o spracúvaní osobných údajov.
      </p>
      <h2>Kontakt</h2>
      <p>V prípade, že budete mať k problematike cookies akékoľvek otázky, neváhajte nás kontaktovať:</p>
      <p>
        E-mail: <a href="mailto:jeviste@dramox.cz">jeviste@dramox.cz</a>
      </p>
      <p>Adresa: Dramox s.r.o., Bucharova 2928/14a, Stodůlky, 158 00 Praha 5</p>
      <p>Tieto pravidlá nadobúdajú účinnosť dňom 01.10.2020.</p>
    </>
  );
}

export function enText(): JSX.Element {
  return (
    <>
      <h1>Cookie Policy</h1>
      <h2>Personal data controller</h2>
      <p>
        Dramox s.r.o., with its registered office at Bucharova 2928/14a, Stodůlky, 158 00 Prague 5, Aspira Business
        Centre, a company registered in the Commercial Register kept by the Municipal Court in Prague, Section C, File
        332337
      </p>
      <p>
        Contact e-mail:<a href="mailto:support@dramox.tv"> support@dramox.tv</a>.
      </p>
      <p>
        The objective of this website is to summarise basic information on cookies used on the website www.dramox.tv
      </p>
      <h2>Using Cookies</h2>
      <p>
        Cookies are small text files stored by dramox website on your computer. These files are used to ensure the
        operation or more efficient use of our website and to provide users with certain services and features. Cookies
        may be used or stored on your device only based on your consent, with the exception of cookies that are
        necessary to ensure proper functioning of our website. The purpose of this website is to provide you with the
        necessary information concerning the use of cookies and the storage of cookies on your device so that you can
        freely decide if you want to enable cookies to be stored on your device.
      </p>
      <p>
        Cookies may be either persistent or session cookies. Persistent cookies are text files sent by the server to
        your internet browser, which, once stored by the browser, remain valid until the set expiry date. Session
        cookies will expire at the end of the user’s session after the browser is closed. The purpose of various cookies
        is specified below in this policy.
      </p>
      {cookieText('en')}
      <h2>Changing Your Browser’s Cookie Settings</h2>
      <ul>
        <li>Select whether you wish to accept cookies.</li>
        <li>
          In most internet browsers you can manage your cookies in browser settings. By adjusting your browser settings,
          you can avoid accepting cookies. The method used to block cookies will depend on the browser. You can find
          help in the browser under the relevant tab.
        </li>
        <li>
          For more information on cookies and how to determine what cookies have been set up and how to manage and
          delete them, go to <a href="http://www.aboutcookies.org">www.aboutcookies.org</a> and{' '}
          <a href="http://www.allaboutcookies.org">www.allaboutcookies.org</a>.
        </li>
        <li>
          Please note that in case of a change in the cookies settings, all functions of our service may not be
          available.
        </li>
        <li>
          If you do not accept cookies, their use will be limited to the necessary cookies required for the operation of
          our website and third-party cookies for non-marketing purposes.
        </li>
      </ul>
      <h2>Personal Data and Cookies</h2>
      <p>The personal data we store about you may be associated with selected cookies.</p>
      <h2>Cookies Policy</h2>
      <p>
        This Cookies Policy forms an integral part of the Privacy Policy on our website, where you will find all the
        details on personal data processing.
      </p>
      <h2>Contact Details</h2>
      <p>Should you have any questions regarding the issue of cookies, do not hesitate to contact us:</p>
      <p>
        E-mail: <a href="mailto:support@dramox.tv">support@dramox.tv</a>
      </p>
      <p>Address: Dramox s.r.o., Bucharova 2928/14a, Stodůlky, 158 00 Prague 5</p>
      <p>The present rules come into effect on 1 October 2020.</p>
    </>
  );
}

export function ukText(): JSX.Element {
  return (
    <>
      <h1>Політика щодо файлів cookie</h1>
      <h2>Контролер персональних даних</h2>
      <p>
        ТОВ Драмокс (чес. Dramox s.r.o.), з місцем знаходження: вул. Бухарова 2928/14а, Стодулки, п. і. 158 00, Прага 5
        (чес. Bucharova 2928 / 14a, Stodůlky, 158 00 Praha 5), Бізнес-центр Aspira (Aspira Business Centre), компанія,
        зареєстрована в торговому реєстрі, який ведеться в міському суді в Празі, відділ Ц, вкладка 332337
      </p>
      <p>
        Контактна електронна пошта:<a href="mailto:pidtrymka@dramox.tv"> pidtrymka@dramox.tv</a>.
      </p>
      <p>
        Метою цієї сторінки є узагальнення основної інформації про файли cookie, які використовуються на веб-сайті
        www.dramox.com.ua
      </p>
      <h2>Використання файлів cookie</h2>
      <p>
        Файли cookie – це невеликі текстові файли, які веб-сайт Dramox зберігає на вашому комп’ютері. Ці файли
        використовуються для забезпечення роботи або більш ефективного використання нашого веб-сайту, а також для
        надання певних послуг і функцій користувачам. Файли cookie можуть зберігатися або використовуватися на вашому
        пристрої лише з вашої згоди, за винятком тих файлів cookie, які необхідні для забезпечення функціональності
        нашого веб-сайту. Метою цього веб-сайту є надання вам необхідної інформації щодо використання файлів cookie та
        їхнього зберігання на вашому пристрої, щоб ви могли вільно вирішувати, чи хочете ви дозволити збереження файлів
        cookie на вашому пристрої.
      </p>
      <p>
        Файли cookie можуть бути постійними або дійсними протягом так званої сесії. Постійні файли cookie – це текстові
        файли, надіслані сервером у ваш інтернет-браузер, які після збереження браузером залишаються дійсними до
        встановленого терміну дії. Файли cookie, дійсні протягом сесії, стануть недійсними в кінці сесії користувача
        після закриття браузера. Мета використання різних файлів cookie зазначена нижче в нашій політиці використання
        cookie.
      </p>
      {cookieText('uk')}
      <h2>Змініть налаштування файлів cookie в браузері</h2>
      <ul>
        <li>Виберіть, чи хочете ви приймати файли cookie.</li>
        <li>
          У більшості інтернет-браузерів ви можете керувати зазначеними вище файлами cookie в налаштуваннях браузера.
          Налаштувавши свій інтернет-браузер, ви можете уникнути прийняття файлів cookie. Спосіб блокування файлів
          cookie залежить від веб-браузера. Ви можете знайти довідку у браузері на відповідній вкладці.
        </li>
        <li>
          Щоб знайти додаткову інформацію про файли cookie та щоб дізнатися, які файли cookie були налаштовані, а також
          як ними керувати та видаляти їх, відвідайте веб-сайти{' '}
          <a href="http://www.aboutcookies.org">www.aboutcookies.org</a> та{' '}
          <a href="http://www.allaboutcookies.org">www.allaboutcookies.org</a>.
        </li>
        <li>
          Зверніть увагу, що якщо ви зміните налаштування файлів cookie, то не всі наші функції та послуги можуть бути
          доступні.
        </li>
        <li>
          Якщо ви не приймаєте файли cookie, їх використання буде обмежено обов’язковими файлами cookie, необхідними для
          роботи нашого веб-сайту, та файлами cookie третіх сторін для немаркетингових цілей.
        </li>
      </ul>
      <h2>Персональні дані та файли cookie</h2>
      <p>Персональні дані, які ми зберігаємо про вас, можуть бути пов’язані з вибраними файлами cookie.</p>
      <h2>Політика обробки персональних даних при використанні файлів cookie</h2>
      <p>
        Ця Політика щодо використання файлів cookie є невід’ємною частиною Політики конфіденційності на нашому
        веб-сайті, де ви знайдете всі деталі обробки персональних даних.
      </p>
      <h2>Контакти</h2>
      <p>Якщо у вас виникли запитання щодо файлів cookie, не соромтеся звертатися до нас:</p>
      <p>
        Електронна пошта: <a href="mailto:pidtrymka@dramox.tv">pidtrymka@dramox.tv</a>
      </p>
      <p>Адреса: Dramox s.r.o., Bucharova 2928 / 14a, Stodůlky, 158 00 Praha 5</p>
      <p>Ці правила набирають чинності 1 жовтня 2020 року.</p>
    </>
  );
}

export function plText(): JSX.Element {
  return (
    <>
      <h1>Polityka plików cookies („Polityka”)</h1>
      <h2>Administrator danych osobowych:</h2>
      <p>
        Dramox s.r.o., z siedzibą w Pradze, adres: Bucharova 2928/14a, Stodůlky, 158 00 Praga 5, Aspira Business Centre,
        Republika Czeska, spółka z ograniczoną odpowiedzialnością zarejestrowana w Rejestrze Handlowym prowadzonym przez
        Sąd Miejski w Pradze, dział C, plik 332337 (&bdquo;<strong>Administrator</strong>&ldquo;)
      </p>
      <p>
        adres e-mail: <a href="mailto:sufler@dramox.pl">sufler@dramox.pl</a>
      </p>
      <p>
        Celem Polityki jest podsumowanie najważniejszych informacji o plikach cookies (tzw. „ciasteczkach”)
        wykorzystywanych na stronie: <a href="https://www.dramox.pl">www.dramox.pl</a> (&bdquo;
        <strong>Portal</strong>&ldquo;).
      </p>

      <h2>Wykorzystanie plików cookies</h2>
      <p>
        Pliki cookies to małe pliki tekstowe, które Portal zapisuje na Twoim komputerze. Pliki te są wykorzystywane w
        celu zapewnienia odpowiedniego działania lub bardziej efektywnego korzystania z Portalu oraz świadczenia
        niektórych usług i oferowania funkcji naszym użytkownikom. Pliki cookies mogą być przechowywane lub
        wykorzystywane na Twoim urządzeniu wyłącznie za Twoją zgodą, z wyjątkiem niezbędnych plików cookies, które
        zapewniają funkcjonowanie Portalu. Celem Polityki jest dostarczenie Ci wszelkich istotnych informacji
        dotyczących korzystania z plików cookies i przechowywania plików cookies na Twoim urządzeniu, abyś mógł
        swobodnie decydować, czy chcesz zezwolić na takie przechowywanie.
      </p>
      <p>
        Pliki cookies mogą być stałe lub ważne tylko na czas trwania sesji (tymczasowe). Stałe pliki cookies to pliki
        tekstowe wysyłane przez serwer do Twojej przeglądarki internetowej, które po zapisaniu przez przeglądarkę
        zachowują ważność do ustawionej daty ważności. Tymczasowe pliki cookies wygasają wraz z zakończeniem sesji
        użytkownika po zamknięciu przeglądarki. Cele korzystania z różnych plików cookies są określone poniżej.
      </p>

      <h2>Niezbędne pliki cookies występujące na Portalu</h2>
      <p>
        Niektóre pliki cookies, których używamy, są niezbędne do świadczenia usług w ramach Portalu. Jeśli wyłączysz
        takie pliki cookies w ustawieniach swojej przeglądarki, nie będziesz mógł korzystać z Portalu i usług z nim
        związanych. Używane przez nas pliki cookies na stronach internetowych – w tym na Portalu - oraz powody ich
        używania są wymienione poniżej. Należy pamiętać, że pliki cookies opisane w Polityce są używane na wszystkich
        platformach, za pośrednictwem których dostępne są nasze usługi.
      </p>

      <strong>Funkcjonalne pliki cookies</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: zapewnienie odpowiedniej funkcjonalności strony internetowej</li>
        <li>
          Funkcja: Pomagają zidentyfikować Twój komputer, jeśli wrócisz na naszą stronę internetową (Portal). Pozwalają
          dostosować Portal do Twoich potrzeb.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>

      <strong>Zewnętrzne pliki cookies (analityczne)</strong>
      <p>
        Pliki cookies tego rodzaju są umieszczane przez osoby trzecie, a nie przez Portal. Te pliki cookies mogą być
        używane tylko za Twoją uprzednią zgodą.
      </p>
      <strong>Hotjar</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: Analiza/pomiar</li>
        <li>
          Funkcja: Hotjar wykorzystuje określone pliki cookies w celu identyfikacji odwiedzających, oceny wzorców
          zachowań i analizy ruchu użytkowników.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>
      <strong>Google Analytics</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: Analiza/pomiar</li>
        <li>
          Funkcja: Google używa plików cookies do zbierania statystyk online i śledzenia współczynników konwersji.
        </li>
        <li>Ważność: 2 lata</li>
      </ul>
      <strong>Google Tag Manager</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: Analiza/pomiar</li>
        <li>
          Funkcja: Google używa plików cookies do zbierania statystyk online i śledzenia współczynników konwersji.
        </li>
        <li>Ważność: 1-20 lat</li>
      </ul>

      <h2>Reklamowe pliki cookies</h2>
      <p>
        Te pliki cookies wykorzystywane są w celach marketingowych. Są one umieszczane przez osoby trzecie, a nie przez
        Portal. Możesz wyłączyć takie pliki cookies w dowolnym momencie w ustawieniach przeglądarki – zgodnie z
        poniższym opisem. Zablokowanie tych plików cookies nie wpłynie na działanie Portalu.
      </p>
      <strong>Google Ads</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: wyświetlanie reklam/targetowanie</li>
        <li>
          Funkcja: Witryny używają tych plików cookies do mierzenia skuteczności swoich kampanii marketingowych online.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>
      <strong>Facebook</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: wyświetlanie reklam/targetowanie</li>
        <li>
          Funkcja: Witryny używają tych plików cookies do mierzenia skuteczności swoich kampanii marketingowych online.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>
      <strong>Sklik</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: wyświetlanie reklam/targetowanie</li>
        <li>
          Funkcja: Witryny używają tych plików cookies do mierzenia skuteczności swoich kampanii marketingowych online.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>
      <strong>Google Remarketing</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: wyświetlanie reklam/targetowanie</li>
        <li>
          Funkcja: Witryny używają tych plików cookies do mierzenia skuteczności swoich kampanii marketingowych online.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>

      <h2>Zmiana ustawień dot. plików cookies w przeglądarce</h2>
      <ol>
        <li>
          Wybierz, czy akceptujesz pliki cookies poprzez wybór odpowiedniej opcji przedstawionej na Portalu i
          dostosowanie ustawień.
        </li>
        <li>
          W przypadku większości przeglądarek internetowych włączaniem i wyłączaniem plików cookies można zarządzać za
          pomocą ustawień przeglądarki. Sposób wyłączenia plików cookies zależy od przeglądarki internetowej. Pomoc
          znajdziesz w swojej przeglądarce w odpowiedniej zakładce.
        </li>
        <li>
          Więcej informacji na temat zarządzania plikami cookies oraz zmiany ustawień dotyczących plików cookies można
          znaleźć na stronach: <a href="https://www.aboutcookies.org">www.aboutcookies.org</a> oraz
          <a href="https://www.allaboutcookies.org">www.allaboutcookies.org</a>.
        </li>
        <li>
          Należy pamiętać, że w przypadku zmiany ustawień dotyczących plików cookies nie wszystkie funkcje Portalu mogą
          być dostępne.
        </li>
        <li>
          Jeśli nie akceptujesz plików cookies, ich użycie będzie ograniczone do niezbędnych plików cookies, które są
          wymagane do działania Portalu oraz plików cookies osób trzecich wykorzystywanych w celach niemarketingowych.
        </li>
      </ol>
      <h2>Dane osobowe i pliki cookies</h2>
      <p>Twoje dane osobowe, które przechowujemy, mogą być powiązane z wybranymi plikami cookies.</p>
      <h2>Zasady przetwarzania danych osobowych podczas korzystania z plików cookies</h2>
      <p>
        Niniejsza Polityka stanowi integralną część Polityki Prywatności Portalu, w której znajdziesz wszystkie
        szczegóły dotyczące przetwarzania danych osobowych.
      </p>
      <h2>Dane kontaktowe</h2>
      <p>
        Jeżeli masz jakiekolwiek pytania dotyczące plików cookies, skontaktuj się z nami:
        <br />
        <br />
        <strong>E-mail:</strong> <a href="mailto:sufler@dramox.pl">sufler@dramox.pl</a>
        <br />
        <strong>Adres:</strong> Dramox s.r.o., Bucharova 2928 / 14a, Stodůlky, 158 00 Praga 5, Republika Czeska
      </p>
      <p>Polityka wchodzi w życie z dniem: 1.11.2022.</p>
    </>
  );
}
